exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/layouts/admin/admin.component.scss
// module id = ../../../../../src-admin/app/layouts/admin/admin.component.scss
// module chunks = main